import "core-js/modules/es.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ref } from '@vue/composition-api';
import axios from '@/services/axios';

var shareModel = function shareModel(params) {
  var commodityImage = ref('');
  var freeBuyInfo = ref({});
  var userInfo = ref({});
  var commodityInfo = ref({});
  var isNormal = ref(true);

  var initData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _freeBuyInfo$value$co, _freeBuyInfo$value, _freeBuyInfo$value$co2, _freeBuyInfo$value2;

      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.get('/rest/w/promotion/freebuy/group/landing', {
                params: params
              });

            case 2:
              res = _context.sent;
              freeBuyInfo.value = res.freeBuyGroup;
              commodityImage.value = (_freeBuyInfo$value$co = (_freeBuyInfo$value = freeBuyInfo.value) === null || _freeBuyInfo$value === void 0 ? void 0 : (_freeBuyInfo$value$co2 = _freeBuyInfo$value.commodity) === null || _freeBuyInfo$value$co2 === void 0 ? void 0 : _freeBuyInfo$value$co2.priceImage) !== null && _freeBuyInfo$value$co !== void 0 ? _freeBuyInfo$value$co : '';
              userInfo.value = res.userInfo;
              commodityInfo.value = (_freeBuyInfo$value2 = freeBuyInfo.value) === null || _freeBuyInfo$value2 === void 0 ? void 0 : _freeBuyInfo$value2.commodity;
              isNormal.value = res.result === 1 && !!freeBuyInfo.value && !!Object.keys(freeBuyInfo.value).length;
              return _context.abrupt("return", res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function initData() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    initData: initData,
    commodityImage: commodityImage,
    freeBuyInfo: freeBuyInfo,
    userInfo: userInfo,
    commodityInfo: commodityInfo,
    isNormal: isNormal
  };
};

export default shareModel;